var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneratePageMarvin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 265,
    height: 240,
    viewBox: "0 0 265 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.877 108.357C228.877 149.992 186.689 172.487 149.888 185.052C114.311 197.2 71.5943 201.516 49.7605 168.829C28.0689 136.357 43.243 92.0637 67.6228 61.8953C86.1333 38.9885 116.358 44.851 143.537 52.7837C178.38 62.9488 225.008 69.4213 226.878 108.358",
    fill: "url(#paint0_linear_1149_127730)",
    fillOpacity: 0.08
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.895 7.74155C236.012 7.74155 237.728 6.01003 237.728 3.8741C237.728 1.73817 236.012 0.00665283 233.895 0.00665283C231.779 0.00665283 230.062 1.73817 230.062 3.8741C230.062 6.01003 231.779 7.74155 233.895 7.74155Z",
    fill: "#FB8B23"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.78 28.5786C237.839 28.5786 238.697 27.7125 238.697 26.6442C238.697 25.5758 237.839 24.7098 236.78 24.7098C235.722 24.7098 234.863 25.5758 234.863 26.6442C234.863 27.7125 235.722 28.5786 236.78 28.5786Z",
    fill: "#FB8B23"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6941 10.7841H19.1065V9.1777H17.7596V10.7841H16.168V12.1386H17.7556V13.7384H19.1038V12.1386H20.6915L20.6941 10.7841Z",
    fill: "#51087E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.4913 21.7838C44.5501 21.7838 45.4084 20.9178 45.4084 19.8494C45.4084 18.7811 44.5501 17.915 43.4913 17.915C42.4325 17.915 41.5742 18.7811 41.5742 19.8494C41.5742 20.9178 42.4325 21.7838 43.4913 21.7838Z",
    fill: "#FB8B23"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0812 42.3024C21.14 42.3024 21.9983 41.4364 21.9983 40.368C21.9983 39.2997 21.14 38.4337 20.0812 38.4337C19.0224 38.4337 18.1641 39.2997 18.1641 40.368C18.1641 41.4364 19.0224 42.3024 20.0812 42.3024Z",
    fill: "#FB8B23"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.911 239.063C131.028 239.063 132.744 237.331 132.744 235.195C132.744 233.059 131.028 231.328 128.911 231.328C126.794 231.328 125.078 233.059 125.078 235.195C125.078 237.331 126.794 239.063 128.911 239.063Z",
    fill: "#51087E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.464 230.43C91.5228 230.43 92.3811 229.564 92.3811 228.495C92.3811 227.427 91.5228 226.561 90.464 226.561C89.4052 226.561 88.5469 227.427 88.5469 228.495C88.5469 229.564 89.4052 230.43 90.464 230.43Z",
    fill: "#51087E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0812 195.396C21.14 195.396 21.9983 194.53 21.9983 193.461C21.9983 192.393 21.14 191.527 20.0812 191.527C19.0224 191.527 18.1641 192.393 18.1641 193.461C18.1641 194.53 19.0224 195.396 20.0812 195.396Z",
    fill: "#FB8B23"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M249.624 187.217H247.007V184.576H245.663V187.217H243.047V188.572H245.663V191.211H247.007V188.572H249.622L249.624 187.217Z",
    fill: "#51087E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1149_127730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 87,
    width: 62,
    height: 60
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.5519 92.5616C97.0835 93.9836 97.4508 95.5481 98.5029 96.6131L103.647 101.079L103.53 100.99L123.097 118.864C124.004 119.692 125.186 120.151 126.414 120.151C127.627 120.151 128.798 119.702 129.7 118.891L138.14 111.306L132.23 105.601L126.569 111.184L105.47 90.3349C104.326 89.2044 102.666 88.7383 101.097 89.0907C99.5005 89.4491 98.19 90.6241 97.6783 92.1778L97.5519 92.5616ZM135.686 102.193L141.758 108.055L149.159 101.404L149.232 143C149.236 145.162 150.99 146.913 153.152 146.913C155.317 146.913 157.072 145.158 157.072 142.993V92.5626C157.072 89.9149 154.925 87.7686 152.278 87.7686C151.018 87.7686 149.808 88.2646 148.911 89.1493L135.686 102.193Z",
    fill: "#1E1E1E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M106.477 114.677L116.045 124.318",
    stroke: "#1E1E1E",
    strokeWidth: 4.65907
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M101.609 117.354L101.608 136.171",
    stroke: "#1E1E1E",
    strokeWidth: 4.65907
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M116.027 129.146L106.394 138.854",
    stroke: "#1E1E1E",
    strokeWidth: 4.65907
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M107.436 112.773C107.436 115.276 105.426 117.282 102.975 117.282C100.524 117.282 98.5144 115.276 98.5144 112.773C98.5144 110.271 100.524 108.265 102.975 108.265C105.426 108.265 107.436 110.271 107.436 112.773Z",
    stroke: "#1E1E1E",
    strokeWidth: 3.45846
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M107.436 140.571C107.436 143.074 105.426 145.08 102.975 145.08C100.524 145.08 98.5144 143.074 98.5144 140.571C98.5144 138.069 100.524 136.063 102.975 136.063C105.426 136.063 107.436 138.069 107.436 140.571Z",
    stroke: "#1E1E1E",
    strokeWidth: 3.45846
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M123.471 127.323C123.471 129.825 121.461 131.831 119.01 131.831C116.559 131.831 114.55 129.825 114.55 127.323C114.55 124.82 116.559 122.814 119.01 122.814C121.461 122.814 123.471 124.82 123.471 127.323Z",
    stroke: "#1E1E1E",
    strokeWidth: 3.45846
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1149_127730)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.6172 105.508C92.6172 89.2037 105.835 75.9863 122.139 75.9863H155.137C171.442 75.9863 184.659 89.2037 184.659 105.508V127.866C184.659 144.17 171.442 157.387 155.137 157.387H122.139C105.835 157.387 92.6172 144.17 92.6172 127.866V105.508Z",
    fill: "url(#paint1_linear_1149_127730)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1149_127730",
    x1: 89.5838,
    y1: 90.7653,
    x2: 151.43,
    y2: 168.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0214029,
    stopColor: "#51087E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB8B23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1149_127730",
    x1: 82.323,
    y1: 75.9863,
    x2: 188.495,
    y2: 81.3415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51087E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.674211,
    stopColor: "#A14653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB8B23"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneratePageMarvin);
export default __webpack_public_path__ + "static/media/generatePageMarvin.32d2d65b9fd88f53f937917ec51687a2.svg";
export { ForwardRef as ReactComponent };